import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import Rem_filter_page from '../layout/header';
import Rem_banner_section from "./section/banner";
import ProfessionalUserMainDetail from './section/ProfessionalUserMainDetail'
import MembershipBarSection from "./section/membershipBarSection";
import ReviewSection from "./section/reviewSection";

import ScrollingNavMenu from "./section/scrollingNavMenu";
import Profile_section from "./section/profileSection";
import ServicesSection from "./section/servicesSections";
import ContactSection from "./section/contactSection";
import DetailReviewSection from "./section/detailReviewSection";
import GallerySection from "./section/gallerySection";
// import OfferSection from "./section/offerSection";
import FaqSection from "./section/faqSection";
import { useTranslation } from "react-i18next";
import i18next from "i18next";


function get_phone(data) {
    try {
        //console.log(data);
        return JSON.parse(data);
    } catch (e) {
        // console.log(address);
        return [data];
    }
}
function get_address(data) {
    try {
        return JSON.parse(data);
    } catch (e) {
        // console.log(address);
        return [data];
    }
}
function Rem_service_single_page(props) {
    const { t, i18n } = useTranslation('common');
    const [company_desc, setCompanyDesc] = useState('');
    useEffect(() => {
        if (props?.lan == 'en') {
            i18next.changeLanguage("en");
        } else {
            i18next.changeLanguage("el");
        }
    }, []);




    return <div class="rem_single_page_nav">
     

        <Rem_filter_page lan={props?.lan} filter_page_ads={props?.filter_page_ads} site_url={props.site_url}></Rem_filter_page>

        {
           <Rem_banner_section lan={props?.lan} site_url={props?.site_url} MetaData={props?.MetaData}  ></Rem_banner_section>
        }
        <ProfessionalUserMainDetail lan={props?.lan}   ratingavgdata={props?.ratingavgdata} featuredImage={props?.featuredImage} site_url={props?.site_url} MetaData={props?.MetaData} data={props?.data}></ProfessionalUserMainDetail>
        <MembershipBarSection site_url={props?.site_url} lan={props?.lan} MetaData={props?.MetaData}></MembershipBarSection>
        <ReviewSection ratingavgdata={props?.ratingavgdata} lan={props?.lan} site_url={props.site_url} data={props?.data}></ReviewSection>
        <ScrollingNavMenu lan={props?.lan} site_url={props.site_url} MetaData={props?.MetaData}></ScrollingNavMenu>
        <Profile_section lan={props?.lan}   company_description2={props?.company_description2} site_url={props?.site_url} data={props?.data} MetaData={props?.MetaData}></Profile_section>
        <ServicesSection lan={props?.lan} site_url={props?.site_url} data={props?.data} MetaData={props?.MetaData}></ServicesSection>
        <ContactSection lan={props?.lan} site_url={props?.site_url} data={props?.data} MetaData={props?.MetaData}></ContactSection>
        <DetailReviewSection lan={props?.lan}  rating_data={props?.rating_data} site_url={props.site_url} data={props?.data}></DetailReviewSection>


        {
            (props?.MetaData?.rem_gallery_enable?.[0] == 'Yes') && (<GallerySection lan={props?.lan} gallery_data={props?.gallery_data} data={props?.data} site_url={props?.site_url} MetaData={props?.MetaData}></GallerySection>)

        }
        {/* <OfferSection lan={props?.lan} MetaData={props?.MetaData}></OfferSection> */}


        {
            (props?.MetaData?.rem_faq_enable?.[0] == 'Yes') && (<FaqSection site_url={props.site_url} lan={props?.lan} MetaData={props?.MetaData}></FaqSection>)
        }
    </div>;
}


export default Rem_service_single_page;